import { render } from "./OrderDetailsView.vue?vue&type=template&id=7e79832f"
import script from "./OrderDetailsView.vue?vue&type=script&lang=js"
export * from "./OrderDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__